import { useMemo } from 'react';
import { useIntl } from 'react-intl';

export const useImportStatusLabels = (): Record<string, string> => {
  const { formatMessage } = useIntl();

  return useMemo(
    () => ({
      added: formatMessage({
        id: 'import.state.addedPlural',
        defaultMessage: 'Tillagda',
      }),
      updated: formatMessage({
        id: 'import.state.updatedPlural',
        defaultMessage: 'Uppdaterade',
      }),
      updatedManuallyModified: formatMessage({
        id: 'import.state.updatedManuallyModifiedPlural',
        defaultMessage: 'Uppdaterade (manuellt ändrade)',
      }),
      restored: formatMessage({
        id: 'import.state.restoredPlural',
        defaultMessage: 'Återställda',
      }),
      removed: formatMessage({
        id: 'import.state.removedPlural',
        defaultMessage: 'Borttagna',
      }),
      skipped: formatMessage({
        id: 'import.state.skippedPlural',
        defaultMessage: 'Överhoppade',
      }),
      failed: formatMessage({
        id: 'import.state.failedPlural',
        defaultMessage: 'Misslyckade',
      }),
      confirmed: formatMessage({
        id: 'import.state.confirmedPlural',
        defaultMessage: 'Bekräftade',
      }),
    }),
    [formatMessage],
  );
};
